module.exports = __webpack_public_path__ + "img/payments.09d8cc9b.png";